export const PRO_POPUP_REFCODES = {
  '3': {
    gaclick: 'popup_upgrade_from_menu',
    gabuynow: 'buynow_upgrade_from_menu',
  },
  '7': {
    gaclick: 'popup_status_applied',
    gabuynow: 'buynow_status_applied',
  },
  '6': {
    gaclick: 'popup_insights_status',
    gabuynow: 'buynow_insights_status',
  },
  '8': {
    gaclick: 'popup_insights_applied_jobs',
    gabuynow: 'buynow_insights_applied_jobs',
  },
  '5': {
    gaclick: 'popup_show_company_jobs',
    gabuynow: 'buynow_show_company_jobs',
  },
  '9': {
    gaclick: 'Premium_Popup_Ad',
    gabuynow: 'Buynow_Premium_Popup_Ad',
  },
  '10': {
    gaclick: 'Premium_Popup_banner',
    gabuynow: 'Buynow_Premium_Popup_Banner',
  },
  '15': {
    gaclick: 'Premium_Mail_Link',
    gabuynow: 'Buynow_Premium_Mail_Link',
  },
  '16': {
    gaclick: 'Premium_Msg_Link',
    gabuynow: 'Buynow_Premium_Msg_Link',
  },
  '17': {
    gaclick: 'jsMenuRenewPro',
    gabuynow: 'Buynow_jsMenuRenewPro',
  },
  '18': {
    gaclick: 'jsMenuReactivatePro',
    gabuynow: 'Buynow_jsMenuReactivatePro',
  },
  '19': {
    gaclick: 'jsMenuUpgradetoPro',
    gabuynow: 'Buynow_jsMenuUpgradetoPro',
  },
  '20': {
    gaclick: 'jsSimilarJobTextLink',
    gabuynow: 'Buynow_jsSimilarJobTextLink',
  },
  '21': {
    gaclick: 'jsJDInsightRightLink',
    gabuynow: 'Buynow_jsJDInsightRightLink',
  },
  '22': {
    gaclick: 'jsAppliedJobsStatusBanner',
    gabuynow: 'Buynow_jsAppliedJobsStatusBanner',
  },
  '23': {
    gaclick: 'jsAppliedJobsFollowupBanner',
    gabuynow: 'Buynow_jsAppliedJobsFollowupBanner',
  },
  '100': {
    gaclick: 'jsIncompletePaymentMail',
    gabuynow: 'Buynow_jsIncompletePaymentMail',
  },
  '24': {
    gaclick: 'jsProfileStatus',
    gabuynow: 'Buynow_jsProfileStatus_Click',
  },
};
